import { render, staticRenderFns } from "./realAuth.vue?vue&type=template&id=49b50613&scoped=true"
import script from "./realAuth.vue?vue&type=script&lang=js"
export * from "./realAuth.vue?vue&type=script&lang=js"
import style0 from "./realAuth.vue?vue&type=style&index=0&id=49b50613&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b50613",
  null
  
)

export default component.exports